import { useTranslation as useI18nTranslation } from 'react-i18next';
import { i18n as I18nType } from 'i18next';

export type TTranslateTextType = (
  key: string,
  options?: Record<string, any>
) => string;

export const useTranslation = (): {
  translateText: TTranslateTextType;
  i18n: I18nType;
} => {
  const { t, i18n } = useI18nTranslation();

  const translateText: TTranslateTextType = (
    key: string,
    options?: Record<string, any>
  ) => {
    const currentLang = i18n.language;
    const translation = t(key, { ...options, returnObjects: false });

    // If translation returns the key itself (not found), try English fallback
    if (translation === key && currentLang !== 'en') {
      return i18n.getFixedT('en')(key, options);
    }

    return translation;
  };

  return { translateText, i18n };
};
